import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-xl font-semibold tracking-tight text-foreground-900">
                  CSS<span className="text-primary-500">Spreadsheet</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Your ultimate resource for CSSBuy Spreadsheet collections, shopping guides, and expert recommendations. Updated weekly with the latest finds.
              </p>
            </div>
            <div>
              <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                Quick Links
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cssbuy-spreadsheet-guide"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Main Website
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                Popular Categories
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://kaspreadsheet.com/category-911-Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Shoes
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Hoodies &amp; Sweaters
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Jackets
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/search-920/name/Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Accessories
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                Resources
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    CSSBuy Sheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    Buy It Now
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} cssspreadsheet.beer. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                Privacy Policy
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}